var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"main-container"},[_c('h3',[_vm._v("Add New Summer Pay Request")]),_c('summer-pay-form',{attrs:{"id":"spr-form"},on:{"submit":_vm.addSummerPayRequest}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }